/** @jsxImportSource @emotion/react */
import React from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { jsx, css } from '@emotion/react';
import { useCompanyPath } from './useCompanyNavigation';

const CompanyLink: React.FC<LinkProps> = (props) => {
  const getCompanyPath = useCompanyPath();
  const {to} = props;
  const newTo = getCompanyPath(to);

  return (<Link {...props} to={newTo}/>);
};

export default CompanyLink;
